import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

const ToolbarGroupContainer = _ref => {
  let {
    className,
    children,
    ...props
  } = _ref;
  return createElement("div", _extends({
    className: className
  }, props), children);
};

export default ToolbarGroupContainer;
//# sourceMappingURL=toolbar-group-container.js.map